module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_ranking2.ac685.png";